import {ValueObject} from '@s-ui/domain'

export class GetModelVersionsRequest extends ValueObject {
  static validate({makeId, modelId, genericVehiclesErrorFactory}) {
    if (!makeId || !modelId) {
      throw genericVehiclesErrorFactory('makeId and modelId are required')
    }
  }
}
